import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNoticeableIrritationSelectedEmoji(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24c0 8.837-7.163 16-16 16S8 32.837 8 24 15.163 8 24 8s16 7.163 16 16Zm-16 3.375c2.317 0 3.795 1.11 4.5 2.05l-1 .75c-.495-.66-1.617-1.55-3.5-1.55-1.859 0-3 .968-3.526 1.582l-.948-.814A5.816 5.816 0 0 1 24 27.375Zm7.4-2.875a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm2.1 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-22.3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-1.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5 1.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.9-5.7a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z",
    fill: "currentColor"
  }));
}

export { SvgNoticeableIrritationSelectedEmoji as default };
